let selectorsElement = {
    modal: ".modal",
    headerClass: ".header--top-default",
    headerIconClass: ".header__icon",
    account: '.header__icon--account',
    dropDownAccount: 'account-drawer',
    cartDrawer: 'cart-drawer',
    active: '.active',
    accountButton: '.header__icon--account',
    cartButton: '.header__icon--cart',
    mobileDrawerButton: '.header__menu--mobile-drawer',
    headerDrawerMobile: 'header-drawer-mobile',
    searchButton: '.header__icon--search',
    searchDrawer: 'search-drawer-mobile',
    headerCartButtonDropdown: ".header__icon--cart"
};

class AccountDrawer extends HTMLElement {
    constructor() {
        super();
        this.accountButton = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.accountButton}`);
        this.setupAccountToggle();
        document.addEventListener('click', (event) => this.handleOutsideClick(event));
    }

    setupAccountToggle() {
        const accountButtons = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.accountButton}`);
        if (!accountButtons.length) return;

        accountButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.toggle(button);
            });
        });
    }

    toggle() {
        if (this.classList.contains('active')) {
            this.close();
        } else {
            this.open();
        }
    }

    removeClassModal() {
        const modalActive = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.modal}`)
        const headerIconActive = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.headerIconClass}`)
        modalActive.forEach((modal)=> {
            modal.classList.remove('active');
        })

        headerIconActive.forEach((icon)=>{
            icon.classList.remove('active');
        })
    }

    open() {
        this.removeClassModal();
        this.accountButton.forEach((button)=>{
            button.classList.add('active');
        })
        this.classList.add('active');
    }

    close() {
        this.accountButton.forEach((button)=>{
            button.classList.remove('active');
        })
        this.classList.remove('active');
    }

    handleOutsideClick(event) {
        const accountButton = document.querySelector(`${selectorsElement.headerClass} ${selectorsElement.accountButton}`);
        if (!this.contains(event.target) && !accountButton.contains(event.target)) {
            this.close();
        }
    }
}


customElements.define('account-drawer', AccountDrawer);